/** Icônes des 3 sous-types AVI — réexport des icônes two-tone « maison » (AviIcons.jsx). */
import { AviValidationIcon, AviAccuseIcon, AviInformationIcon } from "@/components/icons/AviIcons";
export { AviValidationIcon, AviAccuseIcon, AviInformationIcon };

// --------------------------------------------------------------------
// Registre des sous-types (utilisé par le sélecteur d'onglets, la
// modale de création, les listes filtrées, etc.).
// --------------------------------------------------------------------
export const AVI_SUBTYPES = {
  validation: {
    key: "validation", label: "Validation", color: "#5B5FC7",
    Icon: AviValidationIcon, refPrefix: "V", enabled: true,
    createLabel: "Nouvelle demande",
    tagline: "Sollicitez l'approbation ou le refus d'un projet",
  },
  accuse: {
    key: "accuse", label: "Accusé", color: "#F9A826",
    Icon: AviAccuseIcon, refPrefix: "A", enabled: true,
    createLabel: "Nouvel accusé",
    tagline: "Confirmez la réception des notes et informations",
  },
  information: {
    key: "information", label: "Information", color: "#2a9a7a",
    Icon: AviInformationIcon, refPrefix: "I", enabled: true,
    createLabel: "Nouvelle info",
    tagline: "Consultez et diffusez les informations importantes",
  },
};
